import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { PRODUCTS } from '../data/products';

const textLink =
  'text-primary-300 hover:text-primary-200 underline underline-offset-4 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400';

/**
 * Our Work: the flagship portfolio. One write-up per product that already
 * exists in the codebase. Visuals are the product marks we actually have.
 */
const Work: React.FC = () => (
  <div style={{ background: 'radial-gradient(ellipse 80% 40% at 50% 0%, rgba(14,165,233,0.06) 0%, transparent 60%)' }}>
    <section className="page-shell page-section-major">
      <div className="page-inner">
        <header className="mb-6 sm:mb-8">
          <h1 className="text-3xl sm:text-5xl font-bold tracking-tight mb-2">
            <span className="cw">Products </span>
            <span className="cb">&amp; Our Work</span>
          </h1>
          <p className="text-secondary-400">
            What FairCorp has built and is building. Each write-up uses the description already published for that product.
            Commissioned builds are on <Link to="/services" className={textLink}>Services</Link>.
          </p>
        </header>

        <ul className="grid gap-4">
          {PRODUCTS.map((p) => (
            <li key={p.id}>
              <ProductCard product={p} layout="detail" />
            </li>
          ))}
        </ul>
      </div>
    </section>
  </div>
);

export default Work;
